module.exports = __webpack_public_path__ + "img/photo-profile.12502c73.png";